import { render, staticRenderFns } from "./ReviewsView.vue?vue&type=template&id=3c9cfe91&scoped=true&"
import script from "./ReviewsView.vue?vue&type=script&lang=js&"
export * from "./ReviewsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9cfe91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
